import "./resources.scss";
import { Drawer } from "@mui/material";
import { useState } from "react";
import { BrandButton } from "./buttons";
import { imagesUrl } from "../utils";


const Resources = () => {
  const [resourcesOpen, setResourcesOpen] = useState(false);

  return (
    <div className="resources">
      <div className="resourcesBtn" onClick={() => setResourcesOpen(true)}>
        <img src={`${imagesUrl}/resources.svg`}  alt="resources" />
      </div>
      <Drawer anchor="right" open={resourcesOpen} onClose={() => setResourcesOpen(false)}>
        <div className="resourcesDrawerContents">
          <BrandButton onClick={() => setResourcesOpen(false)}>CLOSE</BrandButton>
          <div>
            <img src={`${imagesUrl}/ref_sheet.png`} alt="ref sheet" />
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Resources;
